import React, { Component } from "react";

import { momentModule } from "../../utils/Utils";

import CalendarDay from "./CalendarDay";
import SetPurchaseTariffPlan from "../modals/SetPurchaseTariffPlan";

import "../../../styles/components/chargers/purchaseTariffs/TariffCalendar.scss";

const { moment, formatDate } = momentModule;
moment.locale("en");
const weekDays = moment.weekdays();
moment.locale();

const NUMBER_OF_CELLS = 96;

class TariffCalendar extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      weekDayIndex: null,
      weekDay: null,
      startTime: null,
      stopTime: null,

      modals: {
        setPlan: false,
      },
    };

    this.handleOnClickCell = this.handleOnClickCell.bind(this);
    this.handleOnSetPlanValue = this.handleOnSetPlanValue.bind(this);
    this.handleOnMouseDown = this.handleOnMouseDown.bind(this);
    this.handleOnMouseMove = this.handleOnMouseMove.bind(this);
    this.handleOnMouseUp = this.handleOnMouseUp.bind(this);
    this.setModal = this.setModal.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.tariff?._id !== this.props.tariff?._id) {
      this.resetState();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnClickCell(weekDayIndex, startTime, stopTime, value) {
    // calculate day of the week
    const weekDay = weekDays[weekDayIndex].toLowerCase();

    this.safeSetState(
      {
        weekDayIndex,
        weekDay,
        startTime,
        stopTime,
        value,
      },
      () => this.setModal("setPlan", true)
    );
  }

  handleOnSetPlanValue(e) {
    e.preventDefault();
    const form = e.target;
    const { planValue } = form.elements;
    const { weekDay, startTime, stopTime } = this.state;
    const value = new Number(planValue.value);
    this.props.onEdit({
      weekDay,
      scheduleTime: [
        {
          startTime: formatDate(startTime, "time"),
          stopTime: formatDate(stopTime, "time"),
          value,
        },
      ],
    });
  }

  handleOnMouseDown(e, weekDayIndex, startTime, value) {
    const weekDay = weekDays[weekDayIndex].toLowerCase();
    if (e.buttons === 1)
      this.safeSetState({ weekDay, weekDayIndex, startTime, stopTime: null, value });
  }

  handleOnMouseMove(e, stopTime) {
    if (e.buttons === 1) {
      if (this.state.stopTime !== null && this.state.stopTime.isBefore(this.state.startTime)) {
        this.safeSetState({ startTime: stopTime, stopTime: this.state.startTime });
      } else this.safeSetState({ stopTime });
    }
  }

  handleOnMouseUp(e) {
    const { startTime, stopTime } = this.state;
    if (stopTime?.isAfter(startTime)) this.setModal("setPlan", true);
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  resetState() {
    this.safeSetState({
      weekDayIndex: null,
      weekDay: null,
      startTime: null,
      stopTime: null,
    });
  }

  render() {
    const hourLabels = [];
    for (let i = 0; i <= NUMBER_OF_CELLS; i++) {
      if (i % 4 === 0)
        hourLabels.push(
          <p key={i} className="hour-label">
            {formatDate({ hour: i / 4 }, "time")}
          </p>
        );
      else
        hourLabels.push(
          <p key={i} className="hour-label minutes">
            {formatDate({ hour: i / 4, minute: ((i / 4) % 1) * 60 }, "time")}
          </p>
        );
    }

    return (
      <>
        <div id="tariffCalendar">
          <div className="hour-labels">{hourLabels}</div>
          {weekDays.map((weekday, weekdayIdx) => {
            return (
              <CalendarDay
                key={weekdayIdx}
                config={{ weekdayIdx, weekday, NUMBER_OF_CELLS }}
                schedule={this.props.tariff?.weekSchedule?.find(
                  schedule => schedule.weekDay === weekday.toLowerCase()
                )}
                weekday={this.state.weekDay}
                startTime={this.state.startTime}
                stopTime={this.state.stopTime}
                onClick={(...cellArgs) => this.handleOnClickCell(weekdayIdx, ...cellArgs)}
                onMouseDown={this.handleOnMouseDown}
                onMouseMove={this.handleOnMouseMove}
                onMouseUp={this.handleOnMouseUp}
              />
            );
          })}
        </div>

        <SetPurchaseTariffPlan
          show={this.state.modals.setPlan}
          onHide={() =>
            this.safeSetState({ selectedDay: null, selectedCell: null }, () =>
              this.setModal("setPlan", false)
            )
          }
          weekDayIdx={this.state.weekDayIndex}
          startTime={this.state.startTime}
          stopTime={this.state.stopTime}
          value={this.state.value}
          onSubmit={this.handleOnSetPlanValue}
        />
      </>
    );
  }
}

export default TariffCalendar;
